import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/landing.css'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const goGuias = (e) => {
    e.preventDefault()
    navigate('/guias')
    setIsMenuOpen(false)
  }

  return (
    <header>
      <div style={{ width: '100%', padding: '0 var(--spacing-md)' }}>
        <div className="flex flex-between" style={{ padding: 'var(--spacing-md) 0', alignItems: 'center' }}>
          {/* Logo */}
          <div className="flex flex-center" style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img
              src="/icons/logo.png"
              alt="Vortex EXANI-II"
              style={{
                height: '40px',
                filter: 'brightness(1) invert(0)'
              }}
            />
            <span style={{
              marginLeft: 'var(--spacing-md)',
              fontSize: '1.25rem',
              fontWeight: '700',
              color: 'var(--text-primary)'
            }}>
              Vortex EXANI-II
            </span>
          </div>

          {/* Desktop Navigation */}
            <nav className="desktop-nav" style={{ flex: 1, justifyContent: 'space-between', marginLeft: 'var(--spacing-lg)' }}>
            <button
              onClick={() => navigate('/cursos')}
              className="btn-cursos"
              style={{
                padding: '6px 14px',
                fontSize: '0.9rem',
                background: 'var(--gold-glow-sm)',
                border: '1px solid var(--tech-border)',
                borderRadius: '50px',
                color: 'var(--gold-light)',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                transition: 'all 0.2s ease'
              }}
            >
              <span>🎓</span>
              <span>Cursos Vortex</span>
            </button>
            <a href="#about" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Sobre nosotros</a>
            <a href="#features" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Características</a>
            <a href="#howitworks" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Cómo funciona</a>
            <a href="#testimonials" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Testimonios</a>
            <a href="#screenshots" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Galería</a>
            <a href="#availability" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Descarga</a>
            <a href="/guias" onClick={goGuias} style={{ color: '#c5a059', fontWeight: '700', fontSize: '0.9rem', textDecoration: 'none' }}>Guías oficiales</a>
            <a href="#contact" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Contacto</a>
            <button
              onClick={() => navigate('/purchase-license')}
              className="btn-primary"
              style={{ padding: '8px 25px', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <span>💎</span>
              <span>Adquirir Suscripción</span>
            </button>
            <button
              onClick={() => navigate('/login')}
              className="btn-primary"
              style={{ padding: '8px 25px', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal' }}
            >
              Iniciar sesión
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="mobile-menu-btn"
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="mobile-nav">
            <button
              onClick={() => { navigate('/cursos'); setIsMenuOpen(false); }}
              style={{
                margin: 'var(--spacing-sm) 0',
                background: 'var(--gold-glow-sm)',
                border: '1px solid var(--tech-border)',
                padding: '10px 20px',
                borderRadius: '50px',
                color: 'var(--gold-light)',
                fontWeight: '600',
                fontSize: '0.9rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              <span>🎓</span>
              <span>Cursos Vortex</span>
            </button>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>¿Qué es Vortex?</a>
            <a href="#features" onClick={() => setIsMenuOpen(false)}>Características</a>
            <a href="#howitworks" onClick={() => setIsMenuOpen(false)}>Cómo funciona</a>
            <a href="#testimonials" onClick={() => setIsMenuOpen(false)}>Testimonios</a>
            <a href="#screenshots" onClick={() => setIsMenuOpen(false)}>Galería</a>
            <a href="#availability" onClick={() => setIsMenuOpen(false)}>Descarga</a>
            <a href="/guias" onClick={goGuias}>Guías oficiales</a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contacto</a>
            <button
              onClick={() => { navigate('/purchase-license'); setIsMenuOpen(false); }}
              className="btn-primary"
              style={{ margin: 'var(--spacing-sm) 0', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
            >
              <span>💎</span>
              <span>Adquirir Suscripción</span>
            </button>
            <button
              onClick={() => { navigate('/login'); setIsMenuOpen(false); }}
              className="btn-primary"
              style={{ margin: 'var(--spacing-sm) 0', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal' }}
            >
              Iniciar sesión
            </button>
          </nav>
        )}
      </div>
    </header>
  )
}
